import { CommonModule } from '@angular/common';
import { Component, inject, Input, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SvgIconComponent } from 'angular-svg-icon';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { AuthService } from '../../../core/services/auth.service';

interface menuOptInterface {
  name: string;
  link: string[];
  queryParams?: Record<string, string>;
  type: 'All' | 'Danger';
  exact: boolean;
  icon: string;
  subMenuList?: menuOptInterface[];
}

const menuList: menuOptInterface[] = [
  {
    name: 'Dashboard',
    link: ['/', 'admin'],
    type: 'All',
    exact: true,
    icon: 'assets/svgs/grid.svg',
  },
  {
    name: 'Analytics',
    link: ['/', 'admin', 'analytics'],
    type: 'All',
    exact: true,
    icon: 'assets/svgs/analytic.svg',
  },
  {
    name: 'Factory Entries',
    link: ['/', 'admin', 'factory-entry'],
    type: 'All',
    exact: false,
    icon: 'assets/svgs/file-text.svg',
    subMenuList: [],
  },
  {
    name: 'User Management',
    link: ['/', 'admin', 'settings'],
    queryParams: { tab: 'user-management' },
    type: 'All',
    exact: false,
    icon: 'assets/svgs/users.svg',
    subMenuList: [],
  },
  {
    name: 'Legacy factory data',
    link: ['/', 'admin', 'legacy-factory-data'],
    queryParams: { tab: 'legacy-factory-data' },
    type: 'All',
    exact: false,
    icon: 'assets/svgs/users.svg',
    subMenuList: [],
  },
];

const menuList2: menuOptInterface[] = [
  {
    name: 'Settings',
    link: ['/', 'admin', 'settings'],
    type: 'All',
    exact: false,
    icon: 'assets/svgs/settings.svg',
  },
  {
    name: 'Send Feedback',
    link: ['/', 'admin', 'feedback'],
    type: 'All',
    exact: false,
    icon: 'assets/svgs/thumbs-up.svg',
  },
  {
    name: 'Help',
    link: ['/', 'admin', 'help'],
    type: 'All',
    exact: false,
    icon: 'assets/svgs/help-circle.svg',
  },
  {
    name: 'Log Out',
    link: ['/'],
    type: 'Danger',
    exact: true,
    icon: 'assets/svgs/log-out.svg',
  },
];

@Component({
  selector: 'app-admin-sidemenu',
  standalone: true,
  imports: [
    SvgIconComponent,
    NzToolTipModule,
    RouterModule,
    NgScrollbarModule,
    CommonModule,
    NzMenuModule,
  ],
  templateUrl: './admin-sidemenu.component.html',
  styleUrl: './admin-sidemenu.component.css',
})
export class AdminSidemenuComponent {
  authService = inject(AuthService);

  @Input({ required: true }) isCollapsed = false;

  @Input({ required: true }) slug: string;

  menuList = signal([]);
  menuList2 = signal([]);

  ngOnInit(): void {
    this.menuList.set(
      this.getMenuList().filter((item) => {
        if (
          !['SuperAdmin'].includes(this.authService.userData()?.role) &&
          ['User Management', 'Analytics'].includes(item.name)
        ) {
          return false;
        }

        return true;
      })
    );

    this.menuList2.set(this.getMenuList2());
  }

  getMenuList(): menuOptInterface[] {
    return [
      {
        name: 'Dashboard',
        link: ['/', this.slug],
        type: 'All',
        exact: true,
        icon: 'assets/svgs/grid.svg',
      },
      {
        name: 'Analytics',
        link: ['/', this.slug, 'analytics'],
        type: 'All',
        exact: true,
        icon: 'assets/svgs/analytic.svg',
      },
      {
        name: 'Factory Entries',
        link: ['/', this.slug, 'factory-entry'],
        type: 'All',
        exact: false,
        icon: 'assets/svgs/file-text.svg',
        subMenuList: [],
      },
      {
        name: 'User Management',
        link: ['/', this.slug, 'settings'],
        queryParams: { tab: 'user-management' },
        type: 'All',
        exact: false,
        icon: 'assets/svgs/users.svg',
        subMenuList: [],
      },
      {
        name: 'Legacy factory data',
        link: ['/', this.slug, 'legacy-factory-data'],
        queryParams: { tab: 'user-management' },
        type: 'All',
        exact: false,
        icon: 'assets/svgs/users.svg',
        subMenuList: [],
      },
    ];
  }

  getMenuList2(): menuOptInterface[] {
    return [
      {
        name: 'Settings',
        link: ['/', this.slug, 'settings'],
        type: 'All',
        exact: false,
        icon: 'assets/svgs/settings.svg',
      },
      {
        name: 'Send Feedback',
        link: ['/', this.slug, 'feedback'],
        type: 'All',
        exact: false,
        icon: 'assets/svgs/thumbs-up.svg',
      },
      {
        name: 'Help',
        link: ['/', this.slug, 'help'],
        type: 'All',
        exact: false,
        icon: 'assets/svgs/help-circle.svg',
      },
      {
        name: 'Log Out',
        link: ['/'],
        type: 'Danger',
        exact: true,
        icon: 'assets/svgs/log-out.svg',
      },
    ];
  }
}
